import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./Footer.module.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">

        <div className={styles.brand}>
          <div className={styles.brandLogo}>
            <img
              src={`${process.env.PUBLIC_URL}/triggerflow-mark.svg`}
              alt=""
              width="24"
              height="24"
              aria-hidden="true"
            />
            <span className={styles.name}>TriggerFlow</span>
          </div>
          <p className={styles.tagline}>
            Websites, automation and digital support for businesses.
          </p>
        </div>

        <nav className={styles.links} aria-label="Footer navigation">
          <NavLink to="/" end className={styles.link}>Home</NavLink>
          <NavLink to="/services" className={styles.link}>Services</NavLink>
          <NavLink to="/contact" className={styles.link}>Contact</NavLink>
        </nav>

        <div className={styles.legal}>
          <p>
            <a href="mailto:info@triggerflow.ai">info@triggerflow.ai</a>
          </p>
          <p>© {year} Trigger Flow Ltd. Trading as TriggerFlow.</p>
        </div>

      </div>
    </footer>
  );
}
